/**
 * Third Store is to set common state, getters, mutations and actions for dedicated Store as Company or Contact.
 * It'll be injected in other store
 * Actions are only for reminds that they're required in thirdForm process.
 */
import { buildCustomFields, getCustomFieldsByGroup } from "utils/customfields";
import { getAllCustomFields } from 'api/customfields';
import CompanyApi from "api/companies"

export default {
    state() {
        return {
            third: {
                paramsSettings: {
                    social: {
                        facebook: '',
                        linkedin: '',
                        twitter: ''
                    },
                    note: null,
                },
                customFields: []
            },
            pendingCustomFields: [],
            pendingPerTypeCustomFields: [],
            availablesCustomFields: [],
            sideParams: {
                rateCategories: true,
                note: true,
                social: true,
                smarttags: true
            },
            units: []
        }
    },
    getters: {
        customFields: state => {
            return state.third.customFields;
        },
        pendingCustomFields: state => {
            return state.pendingCustomFields;
        },
        pendingPerTypeCustomFields: state => {
            return state.pendingPerTypeCustomFields;
        },
        getUnits: state => {
            return state.units
        },
        /**
         * 
         * @param {*} state 
         * @returns Array of groups fields 
         * [ {group: { id, name }, fields: [{...}] }]
         */
        groupedCustomFields: (state) => {
            return getCustomFieldsByGroup(state.third.customFields)
        },
        availablesGroupFields: (getters) => {
            return getCustomFieldsByGroup(getters.availablesCustomFields);
        },
        availablesCustomFields: state => {
            return state.availablesCustomFields;
        },
        getDefaultCustomFields: state => {
            return state.defaultCustomFields;
        },
        /**
         * Get params data in form (in side panel)
         */
        getSocial: state => {
            return state.third.paramsSettings.social;
        },
        /**
         * Get params data in form (in side panel)
         */
        getParamsConfig: state => {
            return state.sideParams
        },
        getNote: (state) => {
            return state.third.paramsSettings.note;
        },
    },
    mutations: {
        /**
         * Set customFields and pendingCustomFields 
         * @param {*} state 
         * @param {*} params = {fields (Array): list of customfields, action (String) : type of action }
         * "action" can be :
         *      - "add" when add a new customfield in third store
         *      - "build" when load at create available customfields list
         *      - "update" when change valye in available customfields list
         */
        setCustomFields: (state, params) => {
            let cfs = [...params.fields];
            let pendingCfs = (state.pendingCustomFields && state.pendingCustomFields.length > 0) ? state.pendingCustomFields : [...cfs];
            //is update
            if (params.action === "update" && cfs.length > 0) {
                cfs.forEach(field => {
                    //it matches
                    let index = pendingCfs.findIndex(pendingCustomField => pendingCustomField.id === field.id)
                    if (!_.isNil(field.id) && index >= 0 && pendingCfs[index].value !== field.value) {
                        pendingCfs[index] = field;
                    }
                })
            }
            else if (params.action === "add" && pendingCfs && pendingCfs.length > 0) {
                let pendingByTypeIds = [...state.pendingPerTypeCustomFields].map(cf => cf.id)
                let cfsIds = cfs.map(cf => cf.id)

                //Remove cf in pending
                let cfsWatcherRemove = pendingByTypeIds.filter(id => !cfsIds.includes(id));
                cfsWatcherRemove.forEach(id => {
                    let indexToSlice = pendingCfs.findIndex(cf => cf.id === id);
                    if (indexToSlice >= 0) {
                        pendingCfs.splice(indexToSlice, 1);
                    }
                })

                //Add cf in pending
                let cfsWatcherAdd = cfsIds.filter(id => !pendingByTypeIds.includes(id));
                cfsWatcherAdd.forEach(id => {
                    let cfToInsert = cfs.find(cf => cf.id === id);
                    if (!_.isNil(cfToInsert)) {
                        pendingCfs.push(cfToInsert)
                    }
                })

            } else {
                if (pendingCfs && pendingCfs.length > 0) {
                    cfs.forEach(cf => {
                        let doesExist = pendingCfs.findIndex(ref => ref.id === cf.id);
                        if (doesExist < 0) {
                            pendingCfs.push(cf)
                        }
                    })
                }
            }
            state.pendingCustomFields = pendingCfs;

            //if pendingCustomFields has value
            if (pendingCfs.length > 0) {
                pendingCfs.forEach(field => {
                    let index = cfs.findIndex(cf => cf.id === field.id);
                    // if matching with available custom fields && doesnt exist in current customfields list
                    if (state.availablesCustomFields.findIndex(availablesCustomField => availablesCustomField.id === field.id) >= 0 && index < 0) {
                        cfs.push(field)
                    } else if (index >= 0 && cfs[index] !== field) {
                        cfs[index] = field
                    }
                })
            }

            state.third.customFields = cfs;
        },

        setPendingPerTypeCustomFields: (state, payload) => {
            state.pendingPerTypeCustomFields = payload;
        },
        setAvailablesCustomFields(state, fields) {
            state.availablesCustomFields = fields;
        },
        setUnits: (state, payload) => {
            state.units = payload
        },
        /**
         * update params data in form (in side panel)
         */
        setSocial(state, payload) {
            state.third.paramsSettings.social = payload;
        },
        setNote: (state, payload) => {
            state.third.paramsSettings.note = payload;
        },
        resetCustomFields:(state) =>{
            state.pendingCustomFields = [];
            state.pendingPerTypeCustomFields = [];
        }
    },
    actions: {
        updateThird: () => { },
        clearThird: () => { },
        fetchMetadata: () => { },
        commitMetaData: () => { },

        updateSmartTags: ({ commit }, tags) => {
            commit('setSmartTags', tags);
        },

        addCustomFields: ({ commit, getters }, fields) => {
            const currentFields = _.cloneDeep(getters.customFields);

            getters.customFields.forEach(field => {
                // Never do something with required field
                // Do nothing: Field isn't in Modal Choices (ex: after research some keywords) and not in selected fields, then just return;
                if (field.mandatory || !!getters.availablesCustomFields.find(cf => cf.id === field.id) && !!fields.find(cf => cf.id === field.id)) {
                    return;
                }
                // By next, all fields are not required

                // Remove: Field is in Modal Choices but not in selected fields, then remove it from current form fields
                if (!!getters.availablesCustomFields.find(cf => cf.id === field.id) && !fields.find(cf => cf.id === field.id)) {
                    currentFields.splice(currentFields.findIndex(current => current.id === field.id), 1);
                }
            });

            // Add: at least, field is not in current form fields, add it !
            fields.forEach(field => {
                if (!currentFields.find(cf => cf.id === field.id)) {
                    currentFields.push(field);
                }
            });
            commit('setCustomFields', { action: "add", fields: buildCustomFields(currentFields, getters.getUnits)});
            commit('setPendingPerTypeCustomFields', getters.customFields);
        },
        buildDefaultCustomFields: ({ getters, commit }, fields) => {
            let cfs = buildCustomFields(fields.filter(field => field.mandatory), getters.getUnits);
            commit('setPendingPerTypeCustomFields', []);
            commit('setCustomFields', { action: "build", fields: cfs });
        },

        fetchUnits: ({commit}) => {
            return new Promise((resolve, reject) => {
                ApiClient.get('/units').then(res => {
                    commit("setUnits", res.data.data)
                    resolve()
                }).catch(err=>{
                    reject()
                })
            })
        },
        fetchCustomFields: ({commit}, fields) =>{
            commit('setCustomFields', {action: "add", fields: fields});
        },

        fetchCustomFieldsByType: ({ dispatch, commit }, type) => {
            return new Promise((resolve, reject) => {
                getAllCustomFields(type, { limit: 100 }).then(fields => {
                    commit('setAvailablesCustomFields', fields);
                    dispatch('buildDefaultCustomFields', fields);
                    resolve(fields);
                }).catch(err => {
                    reject(err);
                })
            })
        },

        fetchMandatory: ({}, type)=>{
            return new Promise((resolve, reject) => {
                getAllCustomFields(type, { limit: 100 }).then(fields => {
                    resolve(fields.filter(cf => cf.mandatory === true)?.length > 0);
                }).catch((err)=>{
                    reject(err);
                })
            })
        },

        updateOneCustomField: ({ commit, getters }, field) => {
            const fields = getters.customFields;
            let stateField = fields.find(cf => cf.id === field.id);
            stateField.value = field.value;
            commit('setCustomFields', { action: "update", fields: fields });
        },

        /**
         * Call api to search if company already exists with a similar name
         * @param search : string
        **/
        fetchCompaniesList({}, query) {
            return new Promise((resolve, reject) => {
                let datas = {
                    q: query.search,
                    type: ["company.client", "company.prospect"],
                    limit: 5
                }
                ApiClient.get("/search", datas).then((res) => {
                    resolve(query.siretAllowed ? res.data.data : res.data.data.filter(company => company.name.toUpperCase().indexOf(query.search.toUpperCase()) >= 0))
                }).catch((err) => {
                    reject()
                })
            })
        },

        /**
         * Call to find the list of company with the search companies popup,
         * @param {q: string, countryCode: string, district: string | null} datas 
         * @returns 
        */
        fetchCompaniesSearchScan : ({}, datas) => {
            return new Promise((resolve, reject) => {
                CompanyApi.getCompaniesBySearchScan(datas).then(res =>{
                    let slicedRes = res.data;
                    if(res.data.length > 25){
                        slicedRes = res.data.slice(0, 25)
                    }
                    resolve(slicedRes)
                }).catch(err =>{
                    reject(err)
                })
            });
        },

        /**
         * Call to find all informations of a specific company in search company popup
         * @param {id: int, countryCode : string, siret: int} datas 
         * @returns 
        */
        fetchCompanyBySearchScan: ({},datas) =>{
            return new Promise((resolve, reject) => {
                CompanyApi.getCompanyBySearchScan(datas.id, datas.params).then(res =>{
                    resolve(res.data)
                }).catch(err =>{
                    reject(err)
                })
            });
        },
        /**
         * format the datas of the result of seach and write all new infos in store
         * @param {} entries 
        */
        commitSearchCompany: ({commit}, entries)=>{
            commit("setSearchCompanyDatas", entries);
            
            //Legal and billing settings
            if(entries.address.countryCode === "FR"){
                let jobCode = entries.jobCode;
                if(jobCode && jobCode.indexOf('.') === 2){
                    jobCode = jobCode.replace(".","")
                }
                commit("setLegalFrance", {
                    siren : entries.id,
                    siret : entries.siret,
                    vat : entries.vat,
                    apeNafCode : jobCode,
                    rcsImmatriculation : entries.rcs,
                    companyType : entries.type,
                });
            }
            let capital = (entries.capital ? entries.capital.toString() : null)
            commit("setCapital", capital);

            //Address
            commit("setAddressName", {
                value:window.i18n.__("Adresse principale"),
                index: 0
            });
            commit("setAddressSettings", {
                value:{
                    manualMode: true,
                    line1 : entries.address.address_line_1,
                    line2 : entries.address.address_line_2,
                    city : entries.address.city,
                    postalCode : entries.address.postal_code,
                    countryCode : entries.address.countryCode,
                    country : entries.address.country},
                    index: 0 
                });
            commit("setAddressStatus",{value: true, index: 0});

            let contacts = []
            if(entries.officers){
                entries.officers.forEach((contact)=>{
                    contacts.push({
                        name: contact.firstname,
                        forename : contact.lastname,
                        role : contact.role,
                        id: null
                    })
                })
            }

            commit("setSuggestionContactsList", contacts)
        },
        
        checkIfContactExists: _.debounce(({commit}, search) => {
            return new Promise((resolve, reject) => {
                ApiClient.post("/contacts/search", {order: "name"}, {filters: {email : search}}).then((res)=>{
                    let contacts = []
                    res.data.data.forEach(contact =>{
                        contacts.push({
                            id: contact.id,
                            name : contact.last_name,
                            forename : contact.first_name,
                            email : contact.email
                        })
                    })
                    commit("setContactsList", contacts)
                    resolve(res)
                }).catch((err)=>{
                    reject(err)
                })
            })
        }, 200)
    },
}